import { apiClient } from './client';
import type { SongSummary, SongDetail, ScanResult } from '../types';

export const songsApi = {
  /**
   * Get all songs (summary view)
   */
  async getAllSongs(): Promise<SongSummary[]> {
    return apiClient.get<SongSummary[]>('/api/songs');
  },

  /**
   * Get detailed information for a specific song
   */
  async getSongById(id: number): Promise<SongDetail> {
    return apiClient.get<SongDetail>(`/api/songs/${id}`);
  },

  /**
   * Trigger media folder scan (admin only)
   */
  async scanMedia(): Promise<ScanResult> {
    return apiClient.post<ScanResult>('/api/songs/scan');
  },

  /**
   * Delete a specific song and its files (admin only)
   */
  async deleteSong(id: number): Promise<{ success: boolean; deleted: string }> {
    return apiClient.delete<{ success: boolean; deleted: string }>(`/api/songs/${id}`);
  },

  /**
   * Delete all songs and cleanup all media files (admin only)
   */
  async deleteAllSongs(): Promise<{ success: boolean; deleted: number; message: string }> {
    return apiClient.delete<{ success: boolean; deleted: number; message: string }>('/api/songs/all');
  },

  /**
   * Mark a song as listened for the current user
   */
  async markAsListened(songId: number): Promise<{ success: boolean; songHash: string }> {
    return apiClient.post<{ success: boolean; songHash: string }>(`/api/songs/${songId}/listen`);
  },

  /**
   * Get all listened song hashes for the current user
   */
  async getListenHistory(): Promise<string[]> {
    return apiClient.get<string[]>('/api/songs/listen/history');
  },

  /**
   * Clear listen history for the current user
   */
  async clearListenHistory(): Promise<{ success: boolean }> {
    return apiClient.delete<{ success: boolean }>('/api/songs/listen/history');
  },
};
